import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';
import { interval } from 'rxjs';

@Injectable()
export class UserService {
  private baseURL: string = environment.rootAPI + '/';
  private _authTempNonce = null;
  constructor(private api: ApiService) {}

  private generateNonce() {
    let text = '';
    const allowedChars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const addR = () => {
      text += allowedChars.charAt(
        Math.floor(Math.random() * allowedChars.length)
      );
    };

    for (const i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]) {
      if (i) {
        addR();
      }
    }
    return text;
  }

  private startSocialAuthPolling(cb: Function) {
    const _pollEndPoint = 'login/nonce';
    let _tries = 0;
    const _maxTime = 12;

    const poll = interval(5000).subscribe(s => {
      this.api
        .post(
          'login/nonce',
          {
            nonce: this._authTempNonce
          },
          'auth/'
        )
        .subscribe(
          res => {
            poll.unsubscribe();
            cb(res);
          },
          err => {
            _tries += 1;
            if (_tries > _maxTime) {
              poll.unsubscribe();
              cb({ timedOut: true });
            }
          }
        );
    });
  }

  public social(provider: string, onComplete: Function) {
    this._authTempNonce = this.generateNonce();
    const _base = this.baseURL + 'auth/login/';
    const _nonce = '/?nonce=' + this._authTempNonce;
    switch (provider) {
      case 'google':
        window.open(_base + 'google-oauth2' + _nonce, '_blank');
        break;
      case 'facebook':
        window.open(_base + 'facebook' + _nonce, '_blank');
    }
    this.startSocialAuthPolling(onComplete);
  }
}
